import React, { useEffect, useState } from 'react'
import StopeChart from './StopeChart';

export default function StopeStatistics() {  
  

  return (
    <div className={"flex flex-col absolute  my-auto w-1/4 h-full   bg-gray-100 p-4 overflow-y-auto z-50"}>
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold">{'PK UNDERGROUND STOPE SATISTICS'}</h2>
      </div>
      
      <StopeChart/> 
    </div>
  )
}







